import React, { useState } from "react";
import {
  Accordion,
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.css";
import BookingIcon from "../../assets/icons/easy.svg";
import ReliabilityIcon from "../../assets/icons/shield.svg";
import SafeTravel from "../../assets/icons/recycle.svg";
import MoneyIcon from "../../assets/icons/currency.svg";
import Events from "../../assets/images/events_big.jpg";
import SportTrips from "../../assets/images/sport_trips.jpg";
import CultureTrip from "../../assets/images/culture_trip.jpg";
import SchoolTrip from "../../assets/images/school_trip.jpg";
import Wedding from "../../assets/images/wedding.jpg";
import Tours from "../../assets/images/tours.jpg";
import Tag from "../../assets/icons/online-booking.svg";
import Certificate from "../../assets/icons/badge.svg";
import Card from "../../assets/icons/payment-protection.svg";
import Location from "../../assets/icons/location.svg";
import SmallBus from "../../assets/images/van.svg";
import StandardBus from "../../assets/images/bus.svg";
import LargeBus from "../../assets/images/bus.svg";
import Doubledecker from "../../assets/images/double-decker_.svg";
import multipleBuses from "../../assets/images/multiple-buses.svg";
import SubmitArrow from "../../assets/icons/submit_arrow.svg";
import Slider from "react-slick";
import "../../i18n";
import LogoQuotabus from "../../assets/images/new-logo-full.svg";
import Turnstile from "react-turnstile";
import { analytics } from "../../analytics";
import { logEvent } from "firebase/analytics";

const DEFAULT_UTM_PARAMS = {
  utm_source: "quotabus",
  utm_medium: "lp",
  utm_campaign: "online_sale",
};

const getUrlParameters = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};

  const existingUtmParams = Array.from(searchParams.keys()).filter((key) =>
    key.startsWith("utm_")
  );

  const hasUtmParams = existingUtmParams.length > 0;

  if (!hasUtmParams) {
    Object.assign(params, DEFAULT_UTM_PARAMS);
  }

  for (const key of existingUtmParams) {
    params[key] = searchParams.get(key);
  }

  return params;
};

const getUrl = () => {
  try {
    const urlParams = getUrlParameters();
    const url = new URL("https://app.quotabus.com/VWVOKZL9");

    for (const [key, value] of Object.entries(urlParams)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  } catch (error) {
    return "https://app.quotabus.com/VWVOKZL9?utm_source=quotabus&utm_medium=lp&utm_campaign=online_sale";
  }
};

const Index = () => {
  const { t, i18n } = useTranslation();
  const [activeKey, setActiveKey] = useState(null);
  const [token, setToken] = useState(null);
  const [turnstileError, setTurnstileError] = useState(null);
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    detailsRequest: "",
    acceptTerms: false,
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [touchedFields, setTouchedFields] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [url] = useState(() => getUrl());

  const handleSelect = (eventKey) => {
    setActiveKey(eventKey === activeKey ? null : eventKey);
  };

  const cards = [
    {
      img: Events,
      title: t("company_events_title"),
      description: t("company_events_description"),
    },
    {
      img: SportTrips,
      title: t("sports_trips_title"),
      description: t("sports_trips_description"),
    },
    {
      img: CultureTrip,
      title: t("cultural_trips_title"),
      description: t("cultural_trips_description"),
    },
    {
      img: SchoolTrip,
      title: t("school_trips_title"),
      description: t("school_trips_description"),
    },
    {
      img: Wedding,
      title: t("weddings_title"),
      description: t("weddings_description"),
    },
    {
      img: Tours,
      title: t("group_tours_title"),
      description: t("group_tours_description"),
    },
  ];
  const buses = [
    {
      img: SmallBus,
      alt: "SmallBus",
      title: t("small_bus_title"),
      description: t("small_bus_description"),
    },
    {
      img: StandardBus,
      alt: "StandardBus",
      title: t("standard_bus_title"),
      description: t("standard_bus_description"),
    },
    {
      img: LargeBus,
      alt: "LargeBus",
      title: t("large_bus_title"),
      description: t("large_bus_description"),
    },
    {
      img: Doubledecker,
      alt: "Doubledecker",
      title: t("doubledecker_title"),
      description: t("doubledecker_description"),
    },
    {
      img: multipleBuses,
      alt: "multipleBuses",
      title: t("multiple_buses_title"),
      description: t("multiple_buses_description"),
    },
  ];

  const faqs = [
    {
      question: t("faq1_question"),
      answer: t("faq1_answer"),
    },
    {
      question: t("faq2_question"),
      answer: t("faq2_answer"),
    },
    {
      question: t("faq3_question"),
      answer: t("faq3_answer"),
    },
    {
      question: t("faq4_question"),
      answer: t("faq4_answer"),
    },
    {
      question: t("faq5_question"),
      answer: t("faq5_answer"),
    },
    {
      question: t("faq6_question"),
      answer: t("faq6_answer"),
    },
    {
      question: t("faq7_question"),
      answer: t("faq7_answer"),
    },
    {
      question: t("faq8_question"),
      answer: t("faq8_answer"),
    },
    {
      question: t("faq9_question"),
      answer: t("faq9_answer"),
    },
    {
      question: t("faq10_question"),
      answer: t("faq10_answer"),
    },
  ];

  // Email validation regex
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData((prevData) => ({
      ...prevData,
      [id]: newValue,
    }));

    // For email, only clear errors if email becomes valid
    if (id === "email") {
      if (touchedFields.email && value.length >= 3 && validateEmail(value)) {
        // Only clear the error when the email becomes valid
        setErrors((prevErrors) => ({
          ...prevErrors,
          [id]: "",
        }));
      }
    } else {
      const error = validateField(id, newValue);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: error,
      }));
    }
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;

    // Mark the field as touched
    setTouchedFields((prev) => ({
      ...prev,
      [id]: true,
    }));

    // Validate on blur
    const error = validateField(id, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: error,
    }));
  };

  const validateField = (id, value) => {
    switch (id) {
      case "fullName":
        return value ? "" : t("full_name_required");
      case "phone":
        return value ? "" : t("phone_number_required");
      case "email":
        if (!value) return t("email_required");
        if (value.length >= 3)
          return validateEmail(value) ? "" : t("invalid_email_format");
        return "";
      case "detailsRequest":
        return value ? "" : t("request_details_required");
      case "acceptTerms":
        return value ? "" : t("accept_terms_required");
      default:
        return "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset messages
    setSuccessMessage("");
    setErrorMessage("");
    setTurnstileError(null);

    // Check if the turnstile token is set
    if (!token) {
      setTurnstileError(t("turnstile_token_required"));
      return;
    }

    const newErrors = {
      fullName: validateField("fullName", formData.fullName),
      phone: validateField("phone", formData.phone),
      email: validateField("email", formData.email),
      detailsRequest: validateField("detailsRequest", formData.detailsRequest),
      acceptTerms: validateField("acceptTerms", formData.acceptTerms),
    };

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "new-contact-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            full_name: formData.fullName,
            phone_number: formData.phone,
            request_details: formData.detailsRequest,
            partner_email: process.env.REACT_APP_PARTNER_EMAIL,
            partner_code: process.env.REACT_APP_PARTNER_CODE,
            turnstile_token: token,
          }),
        }
      );

      if (response.ok) {
        setSuccessMessage(t("form_submitted_successfully"));
        if (analytics) {
          logEvent(analytics, "contact_us_submitted", {
            bus_partner: process.env.REACT_APP_PARTNER_CODE,
            user_lang: i18n.language,
          });
        }
        setFormData({
          fullName: "",
          phone: "",
          email: "",
          detailsRequest: "",
          acceptTerms: false,
        });
        setTouchedFields({});
      } else {
        const errorData = await response.json().catch(() => null);
        setErrorMessage(errorData?.message || t("submission_error_message"));
        console.error("Error submitting form:", response.statusText);
      }
    } catch (error) {
      setErrorMessage(t("submission_error_message"));
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to dismiss alerts
  const handleDismissAlert = (type) => {
    if (type === "success") {
      setSuccessMessage("");
    } else if (type === "error") {
      setErrorMessage("");
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section id="home">
        <Container>
          <div className="home_banner_wrapper">
            <div className="heading_wrapper text-center">
              <h1 className="text-shadow">{t("home_banner_title")}</h1>
              <p className="text-shadow">{t("home_banner_subtitle")}</p>
            </div>
            <div className="link_wrapper">
              <Link target="_blank" to={url} className="get_quote">
                {t("get_quote")}
              </Link>
              <p className="text-center call_to_action">
                <a
                  href="mailto:info@quotabusnoleggio.com"
                  className="contact_email"
                >
                  info@quotabusnoleggio.com
                </a>
              </p>
            </div>
          </div>
        </Container>
      </section>
      <section id="boxes_grid">
        <Container>
          <div className="boxes_wrapper">
            <Row className="boxes_container">
              <Col lg={3} md={6}>
                <div className="box">
                  <div className="img_wrapper">
                    <img src={BookingIcon} alt="Booking"></img>
                  </div>
                  <h4>{t("easy_booking_title")}</h4>
                  <p>{t("easy_booking_description")}</p>
                </div>
              </Col>
              <Col lg={3} md={6}>
                <div className="box">
                  <div className="img_wrapper">
                    <img src={MoneyIcon} alt="Booking"></img>
                  </div>
                  <h4>{t("best_value_title")}</h4>
                  <p>{t("best_value_description")}</p>
                </div>
              </Col>
              <Col lg={3} md={6}>
                <div className="box">
                  <div className="img_wrapper">
                    <img src={ReliabilityIcon} alt="Booking"></img>
                  </div>
                  <h4>{t("reliability_title")}</h4>
                  <p>{t("reliability_description")}</p>
                </div>
              </Col>
              <Col lg={3} md={6}>
                <div className="box">
                  <div className="img_wrapper">
                    <img src={SafeTravel} alt="Booking"></img>
                  </div>
                  <h4>{t("safe_travel_title")}</h4>
                  <p>{t("safe_travel_description")}</p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section id="image_gallery_sec">
        <Container>
          <div className="image_wrapper">
            <div className="title_wrapper">
              <h2>{t("caters_variety_travelers")}</h2>
              <p>{t("tailored_solutions")}</p>
            </div>
            <div className="card_wrapper">
              <Row>
                {cards.map((card, index) => (
                  <Col md={4} sm={6} className="cards p-0" key={index}>
                    <div className="card">
                      <img src={card.img} alt={card.title} />
                      <div className="card_details">
                        <h4>{card.title}</h4>
                        <p>{card.description}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="mobile-view">
              <Slider {...settings}>
                {cards.map((card, index) => (
                  <div className="card" key={index}>
                    <img src={card.img} alt={card.title} />
                    <div className="card_details">
                      <h4>{card.title}</h4>
                      <p>{card.description}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </Container>
      </section>
      <section id="how_it_works">
        <Container>
          <div className="title_wrapper">
            <h3>{t("how_it_works")}</h3>
            <p>
              <img
                src={LogoQuotabus}
                alt="Logo"
                style={{
                  filter:
                    "brightness(0) saturate(100%) invert(20%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(92%)",
                  width: "100px",
                  height: "100px",
                  marginRight: "5px",
                }}
              />
              {t("easiest_way")}
            </p>
          </div>
          <div className="step_wrapper">
            <Row className="step_imgs">
              <Col lg={3} className="step_img">
                <div className="img_wrapper">
                  <img src={Tag} alt="Tag" />
                </div>
              </Col>
              <Col lg={3} className="step_img">
                <div className="img_wrapper">
                  <img src={Certificate} alt="Certificate" />
                </div>
              </Col>
              <Col lg={3} className="step_img">
                <div className="img_wrapper">
                  <img src={Card} alt="Card" />
                </div>
              </Col>
              <Col lg={3} className="step_img">
                <div className="img_wrapper">
                  <img src={Location} alt="Location" />
                </div>
              </Col>
            </Row>
            <div className="step_description_wrapper">
              <Row>
                <Col lg={3} className="step_title_main">
                  <div className="step_desc">
                    <div className="step_title">
                      <div>
                        <span>1</span>
                      </div>
                      <p>{t("request_offer")}</p>
                    </div>
                    <div className="step_content">
                      <p>{t("request_offer_description")}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={3} className="step_title_main">
                  <div className="step_desc">
                    <div className="step_title">
                      <div>
                        <span>2</span>
                      </div>
                      <p>{t("receive_best_offer")}</p>
                    </div>
                    <div className="step_content">
                      <p>{t("receive_best_offer_description")}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={3} className="step_title_main">
                  <div className="step_desc">
                    <div className="step_title">
                      <div>
                        <span>3</span>
                      </div>
                      <p>{t("accept_and_pay")}</p>
                    </div>
                    <div className="step_content">
                      <p>{t("accept_and_pay_description")}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={3} className="step_title_main">
                  <div className="step_desc">
                    <div className="step_title">
                      <div>
                        <span>4</span>
                      </div>
                      <p>{t("enjoy_your_trip")}</p>
                    </div>
                    <div className="step_content">
                      <p>{t("enjoy_your_trip_description")}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>
      <section id="book_next_adventure_sec">
        <Container>
          <div
            className="book_adventure_wrapper"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
          >
            <h2>{t("book_next_adventure")}</h2>
            <p>{t("book_next_adventure_description")}</p>
            <div className="button_wrapper">
              <Link to={url} target="_blank">
                {t("get_quote")}
              </Link>
              <a href="#contact_us">{t("call_to_action")}</a>
            </div>
          </div>
        </Container>
      </section>

      <section id="buses_types_sec">
        <Container>
          <div className="buses_type_wrapper">
            <div className="title_wrapper">
              <h3>{t("book_all_types_buses")}</h3>
              <p>{t("multiple_bus_options")}</p>
            </div>
            <div className="buses_cards">
              <Row>
                {buses.map((bus, index) => (
                  <Col className="bus_card" key={index}>
                    <div className="bus_icon">
                      <img src={bus.img} alt={bus.alt} />
                    </div>
                    <h6>{bus.title}</h6>
                    <p>{bus.description}</p>
                    <Link to={url} target="_blank">
                      <span>{t("get_quote")}</span>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="mobile-view">
              <Slider {...settings}>
                {buses.map((bus, index) => (
                  <Col className="bus_card" key={index}>
                    <div className="bus_icon">
                      <img src={bus.img} alt={bus.alt} />
                    </div>
                    <h6>{bus.title}</h6>
                    <p>{bus.description}</p>
                    <Link to={url}>
                      <span>{t("get_quote")}</span>
                    </Link>
                  </Col>
                ))}
              </Slider>
            </div>
          </div>
        </Container>
      </section>
      <section id="contact_us">
        <Container>
          <div className="form_wrapper">
            <div className="title_wrapper">
              <h3>{t("contact_us")}</h3>
              <p>{t("contact_us_description")}</p>
            </div>
            <Form onSubmit={handleSubmit} noValidate>
              {successMessage && (
                <Alert
                  variant="success"
                  dismissible
                  onClose={() => handleDismissAlert("success")}
                >
                  {successMessage}
                </Alert>
              )}
              {errorMessage && (
                <Alert
                  variant="danger"
                  dismissible
                  onClose={() => handleDismissAlert("error")}
                >
                  {errorMessage}
                </Alert>
              )}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="fullName">
                    <Form.Label>{t("full_name")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("your_full_name")}
                      value={formData.fullName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      isInvalid={touchedFields.fullName && !!errors.fullName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fullName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="phone">
                    <Form.Label>{t("phone")}</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder={t("phone_placeholder")}
                      value={formData.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      isInvalid={touchedFields.phone && !!errors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="email" className="mb-3">
                <Form.Label>{t("email")}</Form.Label>
                <Form.Control
                  type="email"
                  placeholder={t("email_placeholder")}
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  isInvalid={touchedFields.email && !!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="detailsRequest" className="mb-3">
                <Form.Label>{t("details_request")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder={t("details_request_placeholder")}
                  value={formData.detailsRequest}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  isInvalid={
                    touchedFields.detailsRequest && !!errors.detailsRequest
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.detailsRequest}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="acceptTerms" className="check_wrapper">
                <Form.Check
                  type="checkbox"
                  label={
                    <>
                      {t("accept_terms_prefix")}
                      <a
                        href="https://partner.quotabus.com/privacy-policy"
                        className="form-link"
                      >
                        {" "}
                        {t("privacy_policy")}{" "}
                      </a>
                      {t("and")}
                      <a
                        href="https://partner.quotabus.com/terms-conditions"
                        className="form-link"
                      >
                        {" "}
                        {t("terms_of_service")}
                      </a>
                      .
                    </>
                  }
                  checked={formData.acceptTerms}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  isInvalid={touchedFields.acceptTerms && !!errors.acceptTerms}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.acceptTerms}
                </Form.Control.Feedback>
              </Form.Group>
              <Turnstile
                theme="light"
                sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                fixedSize={true}
                onVerify={(token) => {
                  setToken(token);
                  setTurnstileError(null);
                }}
                onError={() => {
                  setToken(null);
                  setTurnstileError(t("turnstile_error"));
                }}
                onExpire={() => {
                  setToken(null);
                  setTurnstileError(t("turnstile_expired"));
                }}
              />
              {turnstileError && (
                <div className="text-danger mb-3">{turnstileError}</div>
              )}
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span>{t("submitting")}</span>
                    <div
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </>
                ) : (
                  <>
                    <span>{t("submit")}</span>
                    <img src={SubmitArrow} alt="SubmitArrow" />
                  </>
                )}
              </Button>
            </Form>
          </div>
        </Container>
      </section>
      <section id="faqs">
        <Container>
          <div className="faqs_wrapper">
            <div className="title_wrapper">
              <h3>{t("frequently_asked_questions")}</h3>
              <p>{t("find_answers")}</p>
            </div>
            <Row>
              {faqs.slice(0, Math.ceil(faqs.length / 2)).map((faq, index) => (
                <Col md={6} key={index}>
                  <Accordion
                    activeKey={activeKey}
                    onSelect={handleSelect}
                    className="faq-accordion"
                  >
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Col>
              ))}
              {faqs.slice(Math.ceil(faqs.length / 2)).map((faq, index) => (
                <Col md={6} key={index + Math.ceil(faqs.length / 2)}>
                  <Accordion
                    activeKey={activeKey}
                    onSelect={handleSelect}
                    className="faq-accordion"
                  >
                    <Accordion.Item
                      eventKey={(index + Math.ceil(faqs.length / 2)).toString()}
                    >
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Index;
